<modal-form-container
  [title]="title"
  className="md:w-[720px] lg:w-[760px]"
  [showModal]="open"
  (closeModalEvent)="closeModal()"
>
  @if (open) {
    <div class="pk">
      <div class="sg__bar">
        <app-search-input
          class="sg__search"
          placeholder="Search segments by name"
          [debounce]="300"
          (valueChange)="updateSearchTerm($event)"
        />
        <p class="sg__count" aria-live="polite">
          @if (selectedCount) {
            <span class="sg__count-num">{{ selectedCount }}</span> selected
            <button type="button" class="sg__clear" (click)="clearSelection()">Clear</button>
          } @else {
            None selected
          }
        </p>
      </div>

      <div class="bk-panel sg__panel" [attr.aria-busy]="loading">
        @if (loadError) {
          <div class="sg__state">
            <p class="sg__state-text">{{ loadError }}</p>
            <button type="button" class="bk-btn bk-btn--ghost" (click)="load()">Try again</button>
          </div>
        } @else if (loading && !segments.length) {
          <div class="sg__skel" aria-hidden="true">
            @for (row of [1, 2, 3, 4, 5]; track row) {
              <span class="bk-skel sg__skel-row"></span>
            }
          </div>
          <span class="bk-sr-only">Loading segments</span>
        } @else if (!segments.length) {
          <div class="sg__state">
            <p class="sg__state-text">
              @if (searchTerm.trim()) {
                No segments match “{{ searchTerm.trim() }}”.
              } @else {
                No segments yet. Create one from Contacts, Segments first.
              }
            </p>
          </div>
        } @else {
          <table class="bk-log sg__table" [class.is-loading]="loading">
            <thead>
              <tr>
                <th scope="col" class="sg__check">
                  <input
                    type="checkbox"
                    aria-label="Select every segment on this page"
                    [checked]="getIsAllSelected"
                    [indeterminate]="someSelected"
                    (change)="toggleCheckAll()"
                  />
                </th>
                <th scope="col">Name</th>
                <th scope="col" class="sg__col-2">Created</th>
              </tr>
            </thead>
            <tbody>
              @for (segment of segments; track $index) {
                <tr class="sg__row" [class.is-chosen]="checkedMember(segment)" (click)="select(segment)">
                  <td class="sg__check">
                    <input
                      type="checkbox"
                      [attr.aria-label]="'Select ' + (segment.name || 'segment')"
                      [checked]="checkedMember(segment)"
                      (click)="$event.stopPropagation()"
                      (change)="select(segment)"
                    />
                  </td>
                  <td class="sg__name">
                    <span class="bk-msg">
                      <span class="bk-msg__subject">{{ segment.name || "Untitled segment" }}</span>
                      @if (segment.description) {
                        <span class="bk-msg__preview">{{ segment.description }}</span>
                      }
                    </span>
                  </td>
                  <td class="quiet sg__col-2">{{ created(segment) }}</td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>

      @if (totalPages > 1) {
        <nav class="sg__pager" aria-label="Segment pages">
          <span>{{ rangeLabel }}</span>
          <span class="sg__pager-btns">
            <button
              type="button"
              class="bk-icon-btn"
              aria-label="Previous page"
              [disabled]="page === 0 || loading"
              (click)="goTo(page - 1)"
            >
              <span class="bk-sym" aria-hidden="true">chevron_left</span>
            </button>
            <span class="sg__page">Page {{ page + 1 }} of {{ totalPages }}</span>
            <button
              type="button"
              class="bk-icon-btn"
              aria-label="Next page"
              [disabled]="page >= totalPages - 1 || loading"
              (click)="goTo(page + 1)"
            >
              <span class="bk-sym" aria-hidden="true">chevron_right</span>
            </button>
          </span>
        </nav>
      }

      <div class="pk__foot">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="closeModal()">Cancel</button>
        <!-- With nothing ticked the button clears what the message had; with nothing before either, there is nothing to do. -->
        <button
          type="button"
          class="bk-btn bk-btn--primary"
          [disabled]="!selectedCount && !selection.length"
          (click)="emitSelection()"
        >
          {{ selectedCount ? "Use " + selectedCount + " selected" : selection.length ? "Clear segments" : "Use selected" }}
        </button>
      </div>
    </div>
  }
</modal-form-container>
